import React, { useEffect } from "react";

// 色見本
const COLORS = [
  "ffff00",
  "00b0f0",
  "92d050",
  "ff7c80",
  "ffc000",
  "9966ff",
  "00b050",
  "ff99ff",
  "cccc00",
];

export interface ColorInfo {
  hex: string;
  rgbaThick: string;
  rgbaThin: string;
}

const hexToRgbA = (hex: string, alpha: string): string => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = `0x${c.join("")}`;
    const d: number = parseInt(c, 16);
    // eslint-disable-next-line no-bitwise
    return `rgba(${[(d >> 16) & 255, (d >> 8) & 255, d & 255].join(
      ","
    )},${alpha})`;
  }
  throw new Error("Hexの値が正しくありません。");
};

/**
 * 色コード採番フック
 */
export const useColorProvider = (): ((index: number) => ColorInfo) => {
  const initColor = {
    hex: "#000000",
    rgbaThick: hexToRgbA("#000000", "1"),
    rgbaThin: hexToRgbA("#000000", "0.6"),
  };

  const [colors, setColors] = React.useState<any[]>([initColor]);

  useEffect(() => {
    // eslint-disable-next-line no-shadow
    const colorInfos: ColorInfo[] = COLORS.map((hx: string) => {
      const hex = `#${hx}`;
      return {
        hex,
        rgbaThick: hexToRgbA(hex, "1"),
        rgbaThin: hexToRgbA(hex, "0.6"),
      };
    });
    setColors(colorInfos);
  }, []);

  const getColor = (index: number) => {
    const mod: number = index % colors.length;
    return colors[mod];
  };
  return getColor;
};
